import { Badge } from "@/components/ui/badge";

interface ScheduleFiltersProps {
  selectedType: string | null;
  onTypeChange: (type: string | null) => void;
}

const eventTypes = [
  { value: "all", label: "All", color: "bg-muted" },
  { value: "session", label: "Sessions", color: "bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/30" },
  { value: "meeting", label: "Meetings", color: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30" },
  { value: "task", label: "Tasks", color: "bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/30" },
  { value: "reminder", label: "Reminders", color: "bg-orange-500/10 text-orange-700 dark:text-orange-400 border-orange-500/30" },
];

export const ScheduleFilters = ({ selectedType, onTypeChange }: ScheduleFiltersProps) => {
  return (
    <div className="flex flex-wrap gap-2">
      {eventTypes.map((type) => (
        <Badge
          key={type.value}
          variant={selectedType === type.value || (selectedType === null && type.value === "all") ? "default" : "outline"}
          className={`cursor-pointer transition-all hover:scale-105 ${
            selectedType === type.value || (selectedType === null && type.value === "all")
              ? "shadow-sm"
              : type.color
          }`}
          onClick={() => onTypeChange(type.value === "all" ? null : type.value)}
        >
          {type.label}
        </Badge>
      ))}
    </div>
  );
};
